import { createAction, createAsyncThunk } from '@reduxjs/toolkit';

import { TOKEN_KEY } from 'constants/token';

import * as api from 'api/methods';

import * as types from './types';

export const getUserInfo = createAsyncThunk<any, void>(
  types.GET_USER_INFO,
  async () => {
    const data = await api.getUserInfo();

    return data;
  },
);

export const setCurrentUser = createAction<any>(types.SET_CURRENT_USER);

export const logoutUser = createAction(types.LOGOUT_USER, () => {
  localStorage.removeItem(TOKEN_KEY);

  return { payload: undefined };
});

export const getSchoolById = createAsyncThunk<any, any>(
  types.GET_SCHOOL_BY_ID,
  async (schoolId: string) => {
    const school = await api.getSchoolById(schoolId);

    return school;
  },
);
